import { acronym } from '@goodgamestudios/game-alias'
import { globalState } from '../globalState'
import { criteriaSelector } from '../store'
import { ICreateCatalogUrlProperties } from '../types'
import { getBaseUrlForGame } from '../config'
import { getDomain } from './domain'
import { formatQueryString, ggsGetQueryParams, ggsGetReferrerValue } from './query-params'
import { createSessionId, getTokenAndLanguage } from './session'
import { validateForNull } from './validation'

export const createIframeUrl = ({ page, route, sid, config: igsConfig = {} }: ICreateCatalogUrlProperties): string => {
    const store = globalState.getStore()

    const { token, zoneId, locale } = getTokenAndLanguage(store)
    const parameters = {
        token,
        zoneId,
        locale,
        sid: sid || createSessionId(),
    }

    if (Object.keys(igsConfig).length > 0) {
        // @ts-ignore
        parameters.config = JSON.stringify(igsConfig)
    }

    validateForNull(parameters)

    const urlParameters = new URLSearchParams(ggsGetQueryParams())
    const queryParameters = {
        ...parameters,
        'lemonstand.customization.url': store.resolvedCustomizationUrl || createCustomizationUrl(),
        domain: getDomain(ggsGetReferrerValue()),
        websiteId: urlParameters.get('w'),
        criteria: JSON.stringify(criteriaSelector(store)),
        level: store.level,
    }
    // <editor-fold desc="SPIL integration">
    /* In case of SPIL integration the game can be launched
       with additional params 'network=xx&usekeybaselogin=false'
       in this case it needs to pass the network parameter to iframe url  */
    const network = urlParameters.get('network')
    if (urlParameters.get('usekeybaselogin') === 'false' && Number(network) > 0) {
        // @ts-ignore
        queryParameters.network = network
    }

    if (store.adStatus?.areBannersAvailable) {
        // @ts-ignore
        queryParameters.ads = true
    }
    // </editor-fold>

    const baseUrl = getBaseUrlForGame(store.gameId)
    return `${baseUrl}/?${formatQueryString(queryParameters)}${page ? `#${page}` : ''}${
        route ? `--${route}--${Date.now()}` : ''
    }`
}

export const createCustomizationUrl = (): string => {
    const config = globalState.getConfig()
    const store = globalState.getStore()
    const cxf = globalState.getCxf()

    const configBase = acronym(store.gameId)
    const configVariance = store.customizationSuffix ? `-${store.customizationSuffix}` : ''
    const configBranch = `${configBase}${configVariance}`

    if (cxf.env === 'test') {
        const configVersion = new URLSearchParams(window.location.search).get('configGGS')
        if (configVersion !== null) {
            return config.CUSTOMIZATION_URL_TEMPLATE.replace('{0}', configBranch).replace('{1}', configVersion)
        }
    }
    return config.CUSTOMIZATION_URL.replace('{0}', configBranch)
}
